import { useMemo } from 'react';
import replaceArrayElement from '@sdk/utils/replaceArrayElement';
import { AllBreakTypes } from '@sdk/settings/types';

import { BreakEntry } from '@web/timesheets/CreateTimesheetModal/createTimesheetModal.types';
import { getEmptyBreakEntry } from '@web/timesheets/CreateTimesheetModal/components/TimeClockSections/timeClockSection.utils';
import { UseTimeClockSectionProps } from '@web/timesheets/CreateTimesheetModal/components/TimeClockSections/timeClockSection.types';

export const useTimeClockSection = ({
  timeClockFieldSet,
  submitErrors,
  setSubmitErrors,
}: UseTimeClockSectionProps) => {
  const { breaks } = timeClockFieldSet;

  const addBreak = (
    timeClockEntryKey: string,
    breakType: AllBreakTypes,
    replacesAttestedBreakNumber?: number
  ) => {
    breaks.onChange([
      ...breaks.value,
      getEmptyBreakEntry({ timeClockEntryKey, type: breakType, replacesAttestedBreakNumber }),
    ]);
  };

  const updateBreak = (updatedBreakValue: BreakEntry) => {
    const updatedBreakIndex = breaks.value.findIndex(({ key }) => key === updatedBreakValue.key);
    const updatedBreaks = replaceArrayElement(breaks.value, updatedBreakIndex, updatedBreakValue);
    breaks.onChange(updatedBreaks);
  };

  const removeBreak = (removedBreakValue: BreakEntry) => {
    const removedBreakKey = removedBreakValue.key;
    const timeClockEntryKey = timeClockFieldSet.key.value;

    const removedBreak = { ...removedBreakValue, deleted: true };
    updateBreak(removedBreak);

    if (submitErrors?.breaks?.[timeClockEntryKey]?.[removedBreakKey]) {
      setSubmitErrors({
        ...submitErrors,
        breaks: {
          ...submitErrors.breaks,
          [timeClockEntryKey]: {
            ...submitErrors.breaks[timeClockEntryKey],
            [removedBreakKey]: undefined,
          },
        },
      });
    }
  };

  const visibleBreaks = useMemo(
    () => breaks.value.filter(({ deleted }) => !deleted),
    [breaks.value]
  );

  return {
    addBreak,
    updateBreak,
    removeBreak,
    visibleBreaks,
    breaksFieldError: breaks.error,
  };
};
